import * as React from "react";
import { useAuthentication } from "@montana/containers/authentication";
import { Translate } from "@montana/shared/translate";

export const DealerInfo: React.FC = (): JSX.Element => {
    const { user } = useAuthentication();

    return (
        <div className="dealer-info flex flex-col">
            <h3 className="font-pro-bold text-base leading-5 xl:leading-6 mb-3">
                <Translate value={(t): string => t.checkoutPage.dealerInformation} defaultValue="Dealer information" />
            </h3>
            <p className="display-body mb-3">
                <Translate value={(t): string => t.checkoutPage.customerNumber} defaultValue="Customer no." />
            </p>
            <p className="display-body mb-3">
                {user?.dealerId}
            </p>
        </div>
    )
};
